'use client';

import React from 'react';
import { useAuth } from '@/context/AuthContext';
import { env } from '@/config/env';

interface HeaderProps {
  currentCorrelationId?: string;
  onToggleSidebar?: () => void;
}

export const Header: React.FC<HeaderProps> = ({ currentCorrelationId, onToggleSidebar }) => {
  const { user, logout } = useAuth();

  return (
    <header className="h-14 border-b border-zinc-800 bg-zinc-950/90 backdrop-blur px-4 sm:px-6 flex items-center justify-between sticky top-0 z-30 shrink-0">
      <div className="flex items-center gap-3">
        {onToggleSidebar && (
          <button
            onClick={onToggleSidebar}
            className="lg:hidden text-zinc-400 hover:text-zinc-100 p-1.5 -ml-1.5 rounded hover:bg-zinc-900 transition-colors"
            aria-label="Toggle navigation"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        )}

        <div className="flex items-center gap-2">
          <span className="text-[11px] font-mono px-2 py-0.5 rounded bg-zinc-800 text-zinc-300 uppercase tracking-wider font-semibold">
            {env.environmentName}
          </span>
          <span className="text-[11px] font-mono text-zinc-500 hidden sm:inline">v{env.appVersion}</span>
        </div>

        {currentCorrelationId && (
          <div className="hidden md:flex items-center gap-1.5 text-xs font-mono text-zinc-400 bg-zinc-900 border border-zinc-800 px-2.5 py-0.5 rounded">
            <span className="text-zinc-500">cid:</span>
            <span className="text-zinc-300 truncate max-w-[180px]" title={currentCorrelationId}>
              {currentCorrelationId}
            </span>
          </div>
        )}
      </div>

      <div className="flex items-center gap-3 sm:gap-4">
        {user && (
          <div className="flex items-center gap-2.5 sm:gap-3">
            <div className="text-right hidden sm:block">
              <div className="text-xs font-medium text-zinc-200 leading-tight">{user.displayName}</div>
              <div className="text-[10px] font-mono text-zinc-400 leading-tight">{user.email}</div>
            </div>
            <button
              onClick={logout}
              className="text-xs font-mono px-2.5 py-1 rounded bg-zinc-900 hover:bg-zinc-800 text-zinc-300 border border-zinc-700/80 transition-colors"
            >
              Sign Out
            </button>
          </div>
        )}
      </div>
    </header>
  );
};
